/**
 * View component for /questions/new
 *
 * Creates a new question from a copy of the defaultItem in the question reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as questionActions from '../questionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import question components
import QuestionForm from '../components/QuestionForm.js.jsx';
import QuestionLayout from '../components/QuestionLayout.js.jsx';

class CreateQuestion extends Base {
  constructor(props) {
    super(props);
    this.state = {
      question: _.cloneDeep(this.props.defaultQuestion)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newQuestionState = _.update( this.state.question, e.target.name, function() {
      return e.target.value;
    });
    this.setState({question :newQuestionState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(questionActions.sendCreateQuestion(this.state.question)).then((action) => {
      if(action.success) {
        dispatch(questionActions.invalidateList());
        history.push(`/questions/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { question } = this.state;
    const isEmpty = (question.name === null || question.name === undefined);
    return (
      <QuestionLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <QuestionForm
                question={question}
                cancelLink="/questions"
                formTitle="Create Question"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </QuestionLayout>
    )
  }
}

CreateQuestion.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultQuestion: store.question.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateQuestion)
);



// WEBPACK FOOTER //
// modules/question/views/CreateQuestion.js.jsx